<template>
<div class="chapter">
<div class="inner_page">
<div class="adCardPage" id="ada01"><a id="pageii"><h2 class="adCardHead"><span class="bold"><span>Also available from<br/>
<span class="ss"><span>CHRISTINA SKYE</span></span><br/>
and HQN Books</span></span></h2><p class="adCardSubhead"><span><span class="bold"><span>CODE NAME</span></span></span></p><p class="adCardText"><span><em class="italic"><span>Code Name: Bikini</span></em></span></p><p class="adCardText"><span><em class="italic"><span>Code Name: Blondie</span></em></span></p><p class="adCardText"><span><em class="italic"><span>Code Name: Baby</span></em></span></p><p class="adCardSubhead"><span><span class="bold"><span>DRAYCOTT ABBEY</span></span></span></p><p class="adCardText"><span><em class="italic"><span>To Catch a Thief</span></em></span></p><p class="adCardText"><span><em class="italic"><span>Draycott Eternal</span></em></span></p><p class="adCardText"><span><em class="italic"><span>The Draycott Legacy</span></em></span></p><p class="adCardSubhead"><span><span class="bold"><span>And coming in December 2009</span></span></span></p><p class="adCardText"><span><em class="italic"><span>Bound by Dreams</span></em></span></p></a></div>
<a id="pageii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// draycotteverlasting_ada01.vue?6790c5fa